"use strict";

// const initKuku = () => `Init kuku`;
class CustomControls {
    constructor(initALL = true) {
        console.log('Init CustomControls module');
        if (initALL) {
            this.initSpinners().initTableQtyControls().initConfirmAnchor().initCustomNumberInputs();
        }
    }

    initSpinners() {
        $("<div class='spinner-nav'><a href='#' class='spinner-up'><i class='fas fa-angle-up'></i></a><a href='#' class='spinner-down'><i class='fas fa-angle-down'></i></a></div>").insertAfter('input.spinner');
        $('input.spinner').each((ind, item) => {
            const $spinner = $(item);
            const $up = $spinner.find("+ .spinner-nav > .spinner-up");
            const $down = $spinner.find("+ .spinner-nav > .spinner-down");

            const min = $spinner.prop('min'), max = $spinner.prop('max'), val = +$spinner.val();
            if (max && max < val)
                $spinner.val(max);
            else if (min && min > val)
                $spinner.val(min);

            $up.on('click', () => {
                if (!$spinner.is(":enabled")) return false;

                let newVal = 0;
                let oldValue = parseInt($spinner.val().replace(',', '.'));

                if (max && oldValue >= max) {
                    newVal = oldValue;
                } else {
                    newVal = oldValue + 1;
                }

                $spinner.val(newVal);
                $spinner.trigger("change");

                return false;
            });

            $down.on('click', () => {
                if (!$spinner.is(":enabled")) return false;

                let newVal;
                let oldValue = parseInt($spinner.val().replace(',', '.'));
                if (min && oldValue <= min) {
                    newVal = oldValue;
                } else {
                    newVal = oldValue - 1;
                }
                $spinner.val(newVal);
                $spinner.trigger("change");

                return false;
            });

            $spinner.on("change", () => {
                let oldValue = parseFloat($spinner.val().replace(',', '.'));
                if (max && oldValue > max)
                    $spinner.val(max);
                if (min && oldValue < min)
                    $spinner.val(min);
            }).trigger("change");

            // $spinner.trigger("change");
        });

        return this;
    }

    initTableQtyControls() {
        $(".table-qty-control").each((index, item) => {
            item.innerHTML = '<span class="minus"><i class="fas fa-minus"></i></span>' + '<span class="number">' + item.innerHTML + '</span>' + '<span class="plus"><i class="fas fa-plus"></i></span>';
        });
        $(".table-qty-control > .plus").on('click', event => {
            $(event.currentTarget).parent().find('.number').each((index, item) => {
                let max = $(event.currentTarget).parent().data("max");

                if (!max || (+max > (+item.innerText))) {
                    item.innerText++;
                    $(item).parent().trigger('change');
                }
            });
        });
        $(".table-qty-control > .minus").on('click', event => {
            $(event.currentTarget).parent().find('.number').each((index, item) => {
                let min = $(event.currentTarget).parent().data("min");

                if (!min || (+min < (+item.innerText))) {
                    ((+item.innerText) > 1) ? item.innerText-- : 0;
                    $(item).parent().trigger('change');
                }
            });
        });

        return this;
    }

    initConfirmAnchor() {
        $("a.confirm").on("click", event => {
            return confirm("Вы уверены?");
        });

        return this;
    }

    initCustomNumberInputs() {
        $("input[type=number]").on("change", (event) => {
            let min = +event.currentTarget.min, max = +event.currentTarget.max, val = +event.currentTarget.value;

            if (max > 0 && val > max)
                event.currentTarget.value = max;
            if (val < min)
                event.currentTarget.value = min;
        });

        return this;
    }

    static makeTableQtyControl(tdElement, balance) {
        let $tdElement = $(tdElement),
            tdElementInnerHTML = $tdElement.text();

        if ($tdElement.is("td")) {
            $tdElement.addClass("number table-qty-control");
            $tdElement.html("");
            $tdElement
                .append(
                    $('<span class="minus"><i class="fas fa-minus"></i></span>').on('click', event => {
                        $(event.currentTarget).next('.number').each((index, item) => {
                            let min = $(event.currentTarget).parent().data("min");

                            if (!min || (+min < (+item.innerText))) {
                                ((+item.innerText) > 1) ? item.innerText-- : 0;
                                $(item).parent().trigger('change');
                            }
                        });
                    })
                )
                .append($('<span class="number"/>').text(tdElementInnerHTML))
                .append(
                    $('<span class="plus"><i class="fas fa-plus"></i></span>').on('click', event => {
                        $(event.currentTarget).prev('.number').each((index, item) => {
                            let max = $(event.currentTarget).parent().data("max");

                            if (!max || (+max > (+item.innerText))) {
                                item.innerText++;
                                $(item).parent().trigger('change');
                            }
                        });
                    })
                );
            if (balance) {
                $tdElement.append($('<span class="balance"/>').text("("+balance+")"));
            }
        }
        return $tdElement;
    }

    static makeTableInputSpinner(tdOrTbodyElement, isDisabled) {
        let $element = $(tdOrTbodyElement),
            tagName = $element.prop("tagName").toLowerCase(),
            $spinner;
        switch (tagName) {
            case "td":
                $spinner = $element
                    .append($('<input class="no-border px-3 text-center spinner" type="number" min="0" max="100" value="0"' + (isDisabled ? ' disabled' : '') + '>'))
                    .append($("<div class='spinner-nav'><a href='#' class='spinner-up'><i class='fas fa-angle-up'></i></a><a href='#' class='spinner-down'><i class='fas fa-angle-down'></i></a></div>"))
                    .find(".spinner");
                break;
            case "tbody":
                $spinner = $element.find("input.spinner");
                $spinner.after("<div class='spinner-nav'><a href='#' class='spinner-up'><i class='fas fa-angle-up'></i></a><a href='#' class='spinner-down'><i class='fas fa-angle-down'></i></a></div>");
                break;
            default:
        }

        $spinner.each((ind, item) => {
            const $spinner = $(item);
            const $up = $spinner.find("+ .spinner-nav > .spinner-up");
            const $down = $spinner.find("+ .spinner-nav > .spinner-down");

            const min = $spinner.prop('min'), max = $spinner.prop('max'), val = +$spinner.val();
            if (max && max < val)
                $spinner.val(max);
            else if (min && min > val)
                $spinner.val(min);

            $up.on('click', () => {
                let newVal;
                let oldValue = parseInt($spinner.val().replace(',', '.'));

                if ($spinner.is(":not(:disabled)")) {
                    if (max && oldValue >= max) {
                        newVal = oldValue;
                    } else {
                        newVal = oldValue + 1;
                    }
                    $spinner.val(newVal);
                    $spinner.trigger("change");
                }

                return false;
            });

            $down.on('click', () => {
                let newVal;
                let oldValue = parseInt($spinner.val().replace(',', '.'));

                if ($spinner.is(":not(:disabled)")) {
                    if (min && oldValue <= min) {
                        newVal = oldValue;
                    } else {
                        newVal = oldValue - 1;
                    }
                    $spinner.val(newVal);
                    $spinner.trigger("change");
                }
                return false;
            });

            $spinner.on("change", () => {
                let oldValue = parseFloat($spinner.val().replace(',', '.'));
                if (max && oldValue > max)
                    $spinner.val(max);
                if (min && oldValue < min)
                    $spinner.val(min);
            }).trigger("change");
        });

        return $element;
    }
}

export default CustomControls;